import React, { useState, useCallback, useRef, useContext } from "react";
import Cropper from "react-perspective-cropper";
import Dexie from "dexie";
import { compressImage } from "../Functions/imageCompressionUtil";

import WestIcon from "@mui/icons-material/West";
import closeBtn from "../assest/CloseBtn.svg";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import { Usercontext } from "../context/Usercontexte";
import { addNewItemID } from "../Functions/addNewItemID";
import { useEffect } from "react";
import { checkAndAddReceiptsToDB } from "../Functions/AddReceptTotheLocalDB";
import LoadingBtn from "./LoadingBtn";
export const Cropperr = ({ image, setImage, isLoading, setIsLoading }) => {
  const [cropState, setCropState] = useState();
  const [isBandW, setisBandW] = useState(true);
  const [res, setRes] = useState(null);
  const [accepte, setAccepte] = useState(false);
  const cropperRef = useRef();

  const { setMassage, setReceiptes, setHighlightedItems } =
    useContext(Usercontext);


 
    
  const filterCvParams = {
    th: isBandW,
    grayScale: isBandW,
  };

  const onDragStop = useCallback((s) => setCropState(s), []);
  const onChange = useCallback((s) => setCropState(s), []);

  const doSomething = async () => {
    try {
      // Assuming cropperRef.current.done returns a Blob
      const blobResult = await cropperRef.current.done({
        preview: true,
        filterCvParams,
      });

      // Convert Blob to File
      const fileResult = new File([blobResult], "yourFileName.jpg", {
        type: "image/jpeg",
      });

      console.log(fileResult);
      setRes(fileResult);
      setAccepte(true);
    } catch (e) {
      console.error("Error:", e);
    }
  };
  const returnn = async () => {
    try {
      const res = await cropperRef.current.backToCrop();
      console.log(res);
      setRes(null);
      setAccepte(true);
    } catch (e) {
      console.log("error", e);
    }
  };

  function generateUniqueId() {
    return "_" + Math.random().toString(36).substr(2, 9);
  }



  // accsepting the receipt and store it in the localDB
 async function AccseptReceipt(imageData) {
    const created_at = new Date().toISOString();
 if (imageData) {
      try {
       
 
    const receiptData = {
      id: generateUniqueId(),
      image: imageData,
      file_type: "image",
      source: image?.Source,
      created_at: created_at,
    };
    checkAndAddReceiptsToDB(
      receiptData,
      setMassage,
      addNewItemID,
      setReceiptes,
      setHighlightedItems
    );
    setImage(null);
    }catch (error) {
      // Handle the error as needed
    }
  }
  }

  // ending the loading after the image load
  useEffect(() => {
    if (isLoading) {
      setIsLoading(false);
    }
  }, [isLoading]);

  return (
    <div className="w-full h-full bg-black fixed z-50 flex-col pt-10 justify-center pb-20 overflow-auto flex items-center gap-3 top-0 right-0">
      <span
        className={`text-white flex flex-row   ${
          res ? " justify-between" : "  justify-end"
        } w-full absolute top-3 px-5 right-0`}
      >
        {res && (
          <span onClick={returnn}>
            <WestIcon />
          </span>
        )}

        <img onClick={() => setImage(null)} src={closeBtn} alt="" />
      </span>

      <span className=" relative scale-75 flex items-center justify-center w-[80%] h-[40vh] ">
        {isLoading ? (
          <LoadingBtn color={"#06c671"} isLoading={true} />
        ) : (
          <Cropper
            ref={cropperRef}
            image={image.file} // Use prevImage if it exists, otherwise use the current image
            pointBgColor={"#06c671"}
            pointBorder={"#06c671"}
            lineColor={"#06c671"}
            onChange={onChange}
            onDragStop={onDragStop}
          />
        )}
      </span>
      {res ? (
        <div className=" text-white flex flex-row w-[70%] fixed  bottom-6 justify-between  ">
          <button
            onClick={returnn}
            className=" w-14 h-14  bg-red-400 rounded-full"
          >
            <ClearIcon className=" scale-125" />
          </button>
          <button
            onClick={() => AccseptReceipt(res)}
            className=" w-14 h-14  bg-main rounded-full"
          >
            <DoneIcon className=" scale-125" />
          </button>
        </div>
      ) : (
        <span className=" pl-3 flex flex-row fixed bottom-5 w-[60%]   left-0 justify-between  items-center ">
          <div className="text-white flex flex-col  gap-2  justify-center items-center">
            <button
              onClick={() => {
                setisBandW(!isBandW);
              }}
              className={`relative w-[4rem] h-[1.8rem]  ${
                isBandW ? " bg-main" : " bg-white"
              } border-solid    rounded-full `}
            >
              <span
                className={` ${
                  !isBandW ? "right-[50%] bg-main" : "right-1 bg-white"
                }  ease-out duration-150 h-[85%] w-[1.8rem]  rounded-full  absolute top-[.1rem]   text-white text-center `}
              ></span>
            </button>
            <h1 className="text-xs     text-center  font-bold">
              {!isBandW ? (
                <h1>Original Mode</h1>
              ) : (
                <h1>
                  Black & White <br /> mode
                </h1>
              )}
            </h1>
          </div>
          <button
            className="px-6 py-4 bg-main  rounded-md text-white font-bold"
            onClick={doSomething}
          >
            Done
          </button>
        </span>
      )}
    </div>
  );
};
